import { defineMessages } from 'react-intl';
import { TEAM_MEMBER_CONNECTION_STATUSES } from 'store/features/company-team-member-connections/helpers';

export const connectionStatuses = defineMessages({
  [TEAM_MEMBER_CONNECTION_STATUSES.pendingSignUpByUser]: {
    id: 'admin.companies.team-members.connections.statuses.pending-sign-up',
    defaultMessage: 'Pending Signup',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.pendingEthAddressFromUser]: {
    id: 'admin.companies.team-members.connections.statuses.pending-eth-address',
    defaultMessage: 'Pending Eth Address',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.pendingTransactionSigningByBoth]: {
    id: 'admin.companies.team-members.connections.statuses.pending-transaction-signing-by-both',
    defaultMessage: 'Pending Signing',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.pendingTransactionSigningByUser]: {
    id: 'admin.companies.team-members.connections.statuses.pending-transaction-signing-by-user',
    defaultMessage: 'User Pending Signing',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.pendingTransactionSigningByCompany]: {
    id: 'admin.companies.team-members.connections.statuses.pending-transaction-signing-by-company',
    defaultMessage: 'Company Pending Signing',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.signedByBoth]: {
    id: 'admin.companies.team-members.connections.statuses.signed',
    defaultMessage: 'Verified',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.rejectedByUser]: {
    id: 'admin.companies.team-members.connections.statuses.rejected',
    defaultMessage: 'Rejected',
  },
});

export const connectionActions = defineMessages({
  confirmDelete: {
    id: 'admin.companies.team-members.connections.confirmDelete',
    defaultMessage: 'Are you sure you want to remove this team member?',
  },
  deleted: {
    id: 'admin.companies.team-members.connections.deleted',
    defaultMessage: `{teamMemberName} was removed from {companyName}`,
  },
});

export const pageActions = defineMessages({
  invite: {
    id: 'admin.companies.advisors.connections.invite',
    defaultMessage: 'Invite',
  },
  edit: {
    id: 'admin.companies.advisors.connections.edit',
    defaultMessage: 'Edit',
  },
});



// WEBPACK FOOTER //
// ./src/ui/companies/edit/team-members/messages.js